<script setup lang="ts">
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import List from '@shared/components/List/List.vue';
    import ContactListItem from '@views/Lists/ContactListItem.vue';
    import ContactAdditionalFieldsDropdown from '@views/Lists/components/ContactAdditionalFieldsDropdown.vue';
    import { inject, computed } from 'vue';
    import { SegmentAccess } from '../Segments.access';
    import { ContextAccess } from '@shared/Root/Context.access';
    import { useContactAdditionalFields } from '@views/Lists/useContactAdditionalFields';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const segmentAccess: SegmentAccess = injectorAccess.injector.get(SegmentAccess);
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);

    const { availableFields, selectedFieldNames, selectedFields, toggleField } = useContactAdditionalFields(contextAccess, { hideAddedDateTime: true });

    const allLoaded = computed(() => {
        return segmentAccess.state.segmentPreview?.Result?.length === segmentAccess.state.backgroundCalculationResult?.PagedResult?.Count;
    });

    const isCalculating = computed(() => segmentAccess.state.isBackgroundCalculating);
    const hasResults = computed(() => segmentAccess.state.backgroundCalculationResult !== null);

    const load = (filter: string) => {
        if (filter) {
            segmentAccess.getSegmentPreview(filter);
        } else {
            if (!hasResults.value && !isCalculating.value) {
                segmentAccess.startBackgroundCalculation().catch((error) => {
                    console.error('Error starting background calculation:', error);
                });
            }
        }
    };

    const loadMore = () => {
        segmentAccess.loadMoreContacts();
    };
</script>

<template>
    <List
        itemId="ContactId"
        :items="segmentAccess.state.segmentPreview?.Result"
        :server-side-filter="true"
        :loading="isCalculating || segmentAccess.state.isBackgroundCalculating"
        :all-loaded="allLoaded"
        :filterRateLimit="500"
        @load-more="loadMore"
        @update:filter="(newVal) => load(newVal)">
        <template #toolbar>
            <!-- Additional fields -->
            <ContactAdditionalFieldsDropdown :availableFields="availableFields" :selectedFieldNames="selectedFieldNames" @toggleField="toggleField" />
        </template>
        <template #item="{ item }">
            <ContactListItem :contact="item" :selectedFields="selectedFields" @navigate-to-contact="$emit('navigateToContact', item.ContactId)" />
        </template>
    </List>
</template>
